import React from "react";
import { CancelRounded } from "@material-ui/icons";
import BASIC_COLORS from "../../../colors/basic";
var CloseIcon = function (_a) {
    var onClick = _a.onClick, color = _a.color, size = _a.size, _b = _a.fill, fill = _b === void 0 ? BASIC_COLORS[300] : _b;
    return (React.createElement(CancelRounded, { style: { color: color, fontSize: size, cursor: "pointer", fill: fill }, onClick: onClick }));
};
export default CloseIcon;
//# sourceMappingURL=index.js.map